import endPoints from './endPoints';
import { API } from 'widget/helpers/axios';
import { LocalStorage } from '../../shared/helpers/localStorage';
import { getLastConversationLSKey } from '../helpers/urlParamsHelper';

const createConversationAPI = async content => {
  const urlData = endPoints.createConversation(content);
  return API.post(urlData.url, urlData.params);
};

const sendMessageAPI = async (content, isNewConversation, replyTo = null) => {
  const urlData = endPoints.sendMessage(content, isNewConversation, replyTo);
  return API.post(urlData.url, urlData.params);
};

const sendAttachmentAPI = async data => {
  const urlData = endPoints.sendAttachment(data);
  return API.post(urlData.url, urlData.params);
};

const getMessagesAPI = async ({
  before,
  after,
  conversation_id,
  display_id,
}) => {
  const urlData = endPoints.getConversation({
    before,
    after,
    conversation_id,
    display_id,
  });
  return API.get(urlData.url, { params: urlData.params });
};

const getConversationAPI = async () => {
  const lastConversation = LocalStorage.get(getLastConversationLSKey());
  return API.get(
    `/api/v1/widget/conversations${
      window.location.search
    }&conversation_id=${lastConversation?.id || ''}`
  );
};

const getConversationListAPI = async () => {
  return API.get(`/api/v1/widget/conversations/all${window.location.search}`);
};

const toggleTyping = async ({ typingStatus }) => {
  return API.post(
    `/api/v1/widget/conversations/toggle_typing${window.location.search}`,
    {
      typing_status: typingStatus,
      conversation_id: window.hooryCurrentConversation || '',
    }
  );
};

const setUserLastSeenAt = async ({ lastSeen }) => {
  return API.post(
    `/api/v1/widget/conversations/update_last_seen${window.location.search}`,
    {
      contact_last_seen_at: lastSeen,
      conversation_id: window.hooryCurrentConversation || '',
    }
  );
};
const sendEmailTranscript = async ({ email }) => {
  return API.post(
    `/api/v1/widget/conversations/transcript${window.location.search}`,
    {
      email,
      conversation_id: window.hooryCurrentConversation || '',
    }
  );
};
const toggleStatus = async () => {
  return API.get(
    `/api/v1/widget/conversations/toggle_status${
      window.location.search
    }&conversation_id=${window.hooryCurrentConversation || ''}`
  );
};

const setCustomAttributes = async customAttributes => {
  return API.post(
    `/api/v1/widget/conversations/set_custom_attributes${window.location.search}`,
    {
      custom_attributes: customAttributes,
      conversation_id: window.hooryCurrentConversation || '',
    }
  );
};

const deleteCustomAttribute = async customAttribute => {
  return API.post(
    `/api/v1/widget/conversations/destroy_custom_attributes${window.location.search}`,
    {
      custom_attribute: [customAttribute],
    }
  );
};

export {
  createConversationAPI,
  sendMessageAPI,
  getConversationAPI,
  getConversationListAPI,
  getMessagesAPI,
  sendAttachmentAPI,
  toggleTyping,
  setUserLastSeenAt,
  sendEmailTranscript,
  toggleStatus,
  setCustomAttributes,
  deleteCustomAttribute,
};
